require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./institutionalizing-community-policing.json") })
        }
      }, "path---institutionalizing-community-policing");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---institutionalizing-community-policing!./.cache/json/institutionalizing-community-policing.json
// module id = 910
// module chunks = 231608221292675